(() => {
  document
    .querySelectorAll(".product-steps__container .product-banner__action, .real-weddings-gallery__cta")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const mainBtn = document.querySelector("#digital_appointments_container .servicify-select-a-time-button");
        mainBtn.click();
      });
    });
})();
